import {getPrimerIcon} from '@github-ui/swp-core/lib/utils/icons'
import {Box, Card} from '@primer/react-brand/esm'
import {clsx} from 'clsx'
import {memo} from 'react'
import baseStyles from '../../styles/base.module.css'
import type {IconLinkItem} from '../../types'
import {renderWithoutParagraphs} from '../../utils'

function IconStoryCardComponent({story}: {story: IconLinkItem}) {
  const Octicon = getPrimerIcon(story.fields.icon)

  return (
    <Box
      className={clsx(baseStyles.gridItem, baseStyles.stackedCardGridItem)}
      padding={{narrow: 24, regular: 40, wide: 64}}
      paddingInlineStart={{narrow: 24, regular: 80, wide: 64}}
      paddingInlineEnd={{narrow: 24, regular: 80, wide: 64}}
      paddingBlockStart={{regular: 80}}
      paddingBlockEnd={{regular: 80}}
      borderWidth="thin"
      borderColor="muted"
      style={{height: '100%'}}
    >
      <Card href={story.fields.href} variant="minimal" fullWidth ctaVariant="arrow" ctaText={story.fields.label}>
        {Octicon ? (
          <Card.Icon
            // eslint-disable-next-line react-hooks/static-components -- getPrimerIcon resolves a static octicon from a stable lookup; it is not a dynamically-created component
            icon={<Octicon />}
            color="default"
            hasBackground
          />
        ) : null}
        {story.fields.eyebrow ? <Card.Label>{story.fields.eyebrow}</Card.Label> : null}
        <Card.Heading>
          {renderWithoutParagraphs(story.fields.heading)}
          {story.fields.alt ? <span className="sr-only"> {story.fields.alt}</span> : null}
        </Card.Heading>
        <Card.Description>{renderWithoutParagraphs(story.fields.description)}</Card.Description>
      </Card>
    </Box>
  )
}

export const IconStoryCard = memo(IconStoryCardComponent)
IconStoryCard.displayName = 'IconStoryCard'
